import { useQuery } from "react-query";
import { fetchAdoDashboard, AdoDashboardResult } from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

interface IUseAdoDashboardOptions {
  isProjectWideQuality?: boolean;
}

export const useAdoDashboard = (
  teams: string[],
  startDate: Date,
  endDate: Date,
  priorStartDate: Date,
  priorEndDate: Date,
  comparisonEnabled = true,
  sprints: string[] = [],
  { isProjectWideQuality = false }: IUseAdoDashboardOptions = {},
) => {
  const priorPeriod = comparisonEnabled
    ? { start: priorStartDate, end: priorEndDate }
    : undefined;

  const current = useQuery<AdoDashboardResult[], Error>(
    [
      ADO_QUERY_KEYS.dashboard,
      JSON.stringify([...teams].sort()),
      startDate.toISOString(),
      endDate.toISOString(),
      comparisonEnabled ? priorStartDate.toISOString() : "no-prior",
      comparisonEnabled ? priorEndDate.toISOString() : "no-prior",
      isProjectWideQuality,
      JSON.stringify([...sprints].sort()),
    ],
    () =>
      fetchAdoDashboard(
        teams,
        startDate,
        endDate,
        sprints,
        priorPeriod,
        isProjectWideQuality,
      ),
    {
      staleTime: 5 * 60 * 1000,
      enabled: teams.length > 0 || isProjectWideQuality,
    },
  );
  return { current };
};
